module.exports = __webpack_public_path__ + "img/other_select.4e93084a.png";